import { CoutrProceedingFormComponent } from './app/court-proceedings/court-proceeding/coutr-proceeding-form/coutr-proceeding-form.component';
import { CoutrProceedingGridComponent } from './app/court-proceedings/court-proceeding/coutr-proceeding-grid/coutr-proceeding-grid.component';
import { CoutrProceedingMenuComponent } from './app/court-proceedings/coutr-proceeding-menu/coutr-proceeding-menu.component';
import { FinalReportGridComponent } from './app/final-reports/final-report/final-report-grid/final-report-grid.component';
import { FinalReportFormComponent } from './app/final-reports/final-report/final-report-form/final-report-form.component';
import { FinalReportMenuComponent } from './app/final-reports/final-report-menu/final-report-menu/final-report-menu.component';
import { CaseDairyFormComponent } from './app/case-dairys/case-dairy/case-dairy-form/case-dairy-form.component';
import { CaseDairyGridComponent } from './app/case-dairys/case-dairy/case-dairy-grid/case-dairy-grid.component';
import { CaseDairyMenuComponent } from './app/case-dairys/case-dairy-menu/case-dairy-menu/case-dairy-menu.component';
import { EnquiryReportFormComponent } from './app/enquiry-reports/enquiry-report/enquiry-report-form/enquiry-report-form.component';
import { EnquiryReportGridComponent } from './app/enquiry-reports/enquiry-report/enquiry-report-grid/enquiry-report-grid.component';
import { EnquiryReportMenuComponent } from './app/enquiry-reports/enquiry-report-menu/enquiry-report-menu/enquiry-report-menu.component';

import { ComplaintGridComponent } from './app/Complaints/complaint-grid/complaint-grid.component';
import { JurisdictionGridComponent } from './app/masters/Jurisdiction/jurisdiction-grid/jurisdiction-grid.component';
import { JurisdictionFormComponent } from './app/masters/Jurisdiction/jurisdiction-form/jurisdiction-form.component';
import { ComplaintsFormComponent } from './app/Complaints/complaints-form/complaints-form.component';
import { ComplaintsComponent } from './app/Complaints/complaints.component';
import { MaintenanceFormComponent } from './app/masters/Maintenance-office/maintenance-form/maintenance-form.component';
import { MaintenanceGridComponent } from './app/masters/Maintenance-office/maintenance-grid/maintenance-grid.component';
import { EnactmentFormComponent } from './app/masters/Enactment/enactment-form/enactment-form.component';
import { EnactmentGridComponent } from './app/masters/Enactment/enactment-grid/enactment-grid.component';
import { ComplaintsTypeFormComponent } from './app/masters/Complaints-types/complaints-type-form/complaints-type-form.component';
import { ComplaintsTypeGridComponent } from './app/masters/Complaints-types/complaints-type-grid/complaints-type-grid.component';
import { Routes } from '@angular/router'
import { AppComponent } from './app/khb.component';
import { RegistrationComponent } from './app/registration/registration.component';
import { LoginComponent } from './app/registration/login/login.component';
import { SignupComponent } from './app/registration/signup/signup.component';
import { UltilitiesComponent } from './app/ultilities/ultilities.component';
import { RolesComponent } from './app/ultilities/roles/roles.component';
import { RolesGridComponent } from './app/ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './app/ultilities/roles/roles-form/roles-form.component';
import { UserComponent } from './app/ultilities/user/user.component';
import { UserGridComponent } from './app/ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './app/ultilities/user/user-form/user-form.component';
import { ClaimsComponent } from './app/ultilities/claims/claims/claims.component';
import { ClaimGridComponent } from './app/ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './app/ultilities/claims/claims/claim-form/claim-form.component';
import { SettingComponent } from './app/ultilities/setting/setting.component';
import { HomepageComponent } from './app/homepage/homepage.component';
import { AuthGuard } from './app/auth/auth.guard';
import { ChangePasswordComponent } from './app/ultilities/change-password/change-password.component';
import { MastersComponent } from './app/masters/masters.component';
import { DistrictGridComponent } from './app/masters/district/district-grid/district-grid.component';
import { DistrictFormComponent } from './app/masters/district/district-form/district-form.component';
import { VehicleGridComponent } from './app/ultilities/vehicle/vehicle-grid/vehicle-grid.component';
import { VehicleFormComponent } from './app/ultilities/vehicle/vehicle-form/vehicle-form.component';
import { CorrespondanceTrackingComponent } from './app/correspondance-tracking/correspondance-tracking.component';
import { CtGridComponent } from './app/correspondance-tracking/ct-grid/ct-grid.component';
import { CtFormComponent } from './app/correspondance-tracking/ct-form/ct-form.component';
import { TalukGridComponent } from './app/masters/taluk/taluk-grid/taluk-grid.component';
import { TalukFormComponent } from './app/masters/taluk/taluk-form/taluk-form.component';
import { OfficeGridComponent } from './app/masters/office/office-grid/office-grid.component';
import { OfficeFormComponent } from './app/masters/office/office-form/office-form.component';
import { FirComponent } from './app/FIR/fir.component';
import { FirFormComponent } from './app/FIR/fir-form/fir-form.component';
import { FirGridComponent } from './app/FIR/fir-grid/fir-grid.component';
import { InvestigationDocsComponent } from './app/investigation-docs/investigation-docs.component';
import { InvDocGridComponent } from './app/investigation-docs/inv-doc-grid/inv-doc-grid.component';
import { DepartmentFormComponent } from './app/masters/department/department-form/department-form.component';
import { DepartmentGridComponent } from './app/masters/department/department-grid/department-grid.component';
import { FirProceGridComponent } from './app/investigation-docs/fir-proceeding-list/fir-proce-grid/fir-proce-grid.component';
//import { FirProceFormComponent } from './app/investigation-docs/fir-proceeding-list/fir-proce-form/fir-proce-form.component';
import { ForgotPasswordComponent } from './app/registration/forgot-password/forgot-password.component';
import { InvestigationFormComponent } from './app/investigationdocs-for-investigation/investigation-form/investigation-form.component';
import { InvestigationGridComponent } from './app/investigationdocs-for-investigation/investigation-grid/investigation-grid.component';
import { DeptDocumentGridComponent } from './app/masters/dept-document/dept-document-grid/dept-document-grid.component';
import { DeptDocumentFormComponent } from './app/masters/dept-document/dept-document-form/dept-document-form.component';

// var data = localStorage.getItem("accessToken");
// var defaultPage;
// if(data) defaultPage = "/home"; else defaultPage = "/login";
//canActivate : [AuthGuard],
export const appRoutes: Routes = [
    {
        path: 'home', component: HomepageComponent, canActivate: [AuthGuard],
        children: [
            // {
            //     path: 'password',component: UltilitiesComponent,
            //     children: [{path: '', component: ChangePasswordComponent}]
            // },  

            // {
            //     path: 'password/:userId',component: UltilitiesComponent,
            //     children: [{path: '', component: ChangePasswordComponent}]
            // },  

            // {
            //     path: 'rolesgrid',component: UltilitiesComponent,
            //     children: [{path: '', component: RolesGridComponent}]
            // },  

            // {
            //     path: 'rolesform',component: UltilitiesComponent,
            //     children: [{path: '', component: RolesFormComponent}]
            // },

            // {
            //     path: 'rolesform/:roleId/:mode',component: UltilitiesComponent,
            //     children: [{path: '', component: RolesFormComponent}]
            // },            

            // {
            //     path: 'userlist',component: UltilitiesComponent,
            //     children: [{path: '', component: UserGridComponent}]
            // }, 

            // {
            //     path: 'userform',component: UltilitiesComponent,
            //     children: [{path: '', component: UserFormComponent}]
            // },   

            // {
            //     path: 'userform/:Id/:mode',component: UltilitiesComponent,
            //     children: [{path: '', component: UserFormComponent}]
            // },    

            // {
            //     path: 'claimslist',component: UltilitiesComponent,
            //     children: [{path: '', component: ClaimGridComponent}]
            // },  

            // {
            //     path: 'claimform',component: UltilitiesComponent,
            //     children: [{path: '', component: ClaimFormComponent}]
            // },     

            // {
            //     path: 'claimform/:roleId/:roleName/:officeName',component: UltilitiesComponent,
            //     children: [{path: '', component: ClaimFormComponent}]
            // },

            // {
            //     path: 'claimform/:roleId/:roleName/:officeName',component: UltilitiesComponent,
            //     children: [{path: '', component: ClaimFormComponent},
            // ]
            // }, 
            //utilities
            {
                path: 'password', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },

            {
                path: 'password/:userId', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },


            {
                path: 'office', component: UltilitiesComponent,
                children: [{ path: '', component: OfficeGridComponent },
                { path: 'officeform', component: OfficeFormComponent },
                { path: 'officeform/:OfficeId/:mode', component: OfficeFormComponent }
                ]
            },

            {
                path: 'rolesgrid', component: UltilitiesComponent,
                children: [{ path: '', component: RolesGridComponent },
                { path: 'rolesform', component: RolesFormComponent },
                { path: 'rolesform/:roleId/:mode', component: RolesFormComponent }
                ]
            },



            {
                path: 'user', component: UltilitiesComponent,
                children: [{ path: '', component: UserGridComponent },
                { path: 'userform', component: UserFormComponent },
                { path: 'userform/:Id/:mode', component: UserFormComponent }
                ]
            },


            {
                path: 'claims', component: UltilitiesComponent,
                children: [{ path: '', component: ClaimGridComponent },
                { path: 'claimform/:roleId/:roleName', component: ClaimFormComponent }
                ]
            },

            //


            //sarita master
            {
                path: 'dept-document', component: MastersComponent,
                children: [{ path: '', component: DeptDocumentGridComponent},
                { path: 'dept-document-form', component: DeptDocumentFormComponent},
                //  { path: 'dept-document-form/:dep_Id/:mode', component: DeptDocumentFormComponent }
                { path: 'dept-document-form/:dep_Id', component: DeptDocumentFormComponent },
                ]
            },
            {
                path: 'ctype', component: MastersComponent,
                children: [{ path: '', component: ComplaintsTypeGridComponent },
                { path: 'complaints-type-form', component: ComplaintsTypeFormComponent },
                { path: 'complaints-type-form/:cmplnt_id/:mode', component: ComplaintsTypeFormComponent }
                ]
            },
            {
                path: 'enactments', component: MastersComponent,
                children: [
                    { path: '', component: EnactmentGridComponent },
                    { path: 'enactment-form', component: EnactmentFormComponent },
                    { path: 'enactment-form/:Enactment_id/:mode', component: EnactmentFormComponent }
                ]
            },
            {
                path: 'jurisdiction', component: MastersComponent,
                children: [
                    { path: '', component: JurisdictionGridComponent },
                    { path: 'jurisdiction-form', component: JurisdictionFormComponent },
                    { path: 'jurisdiction-form/:Jurt_id/:mode', component: JurisdictionFormComponent }
                ]
            },
            {
                path: 'moffice', component: MastersComponent,
                children: [{ path: '', component: MaintenanceGridComponent },
                { path: 'moffice-form', component: MaintenanceFormComponent },
                { path: 'moffice-form/:Office_id/:mode', component: MaintenanceFormComponent }
                ]
            },
            {
                path: 'Department', component: MastersComponent,
                children: [{ path: '', component: DepartmentGridComponent },
                { path: 'dep-form', component: DepartmentFormComponent },
                { path: 'dep-form/:dep_Id/:mode', component: DepartmentFormComponent }
                ]
            },


            {
                path: 'complaint', component: ComplaintsComponent,
                children: [{ path: '', component: ComplaintGridComponent },
                { path: 'complaint-form', component: ComplaintsFormComponent },
                { path: 'complaint-form/:Comp_id/:mode', component: ComplaintsFormComponent }]
            },
            {
                path: 'fir', component: FirComponent,
                children: [{ path: '', component: FirGridComponent },
                { path: 'fir-form', component: FirFormComponent },
                { path: 'fir-form/:Fir_id/:mode', component: FirFormComponent }]
            },
            {
                path: 'proceedings', component: InvestigationDocsComponent,
                children: [
                    { path: '', component: InvDocGridComponent },         
                    //{ path: 'fir-prceeding', component: InvestigationFormComponent },           
                    { path: 'fir-prceeding', component: FirProceGridComponent },
                    { path: 'fir-prceeding/:Fir_id', component: FirProceGridComponent },
                    // path: 'fir-prceeding/fir-proceeding-form', component: FirProceFormComponent }
                ]
            },


            // {
            //     path: 'proceedings', component: InvestigationDocsComponent,
            //     children: [{ path: '', component: InvDocGridComponent },
            //     { path: 'io', component: InvestigationFormComponent }
            //     //{ path: 'fir-form/:Fir_id/:mode', component: FirFormComponent }
            // ]
            // },
            
            // {
            //     path: 'Investigation', component: InvestigationDocsComponent,
            //     children: [
            //         { path: '', component: InvestigationGridComponent },                    
            //         { path: 'investigation-form', component:InvestigationFormComponent  },
            //         { path: 'Investigation/:Fir_id', component: InvestigationGridComponent  },
            //         // { path: 'fir-prceeding/fir-proceeding-form', component: FirProceFormComponent },
            //     ]
            // },

            {
                path: 'Investigation', component: InvestigationDocsComponent,
                children: [
                { path: '', component: InvestigationGridComponent },
                { path: 'investigation-form/:Fir_id', component: InvestigationFormComponent },
                // { path: 'investigation-form/:Fir_id', component: InvestigationFormComponent },
                // { path: 'investigation-form/:InvDoc_Id/:mode', component: InvestigationFormComponent}
            ]
            },

            // new 

            {
                path: 'enqiry-report', component: EnquiryReportMenuComponent,
                children: [
                { path: '', component: EnquiryReportGridComponent },
                { path: 'enqiry-report-form/:Comp_id', component: EnquiryReportFormComponent },
               ]
            },

            {
                path: 'case-diary', component: CaseDairyMenuComponent,
                children: [
                { path: '', component: CaseDairyGridComponent },
                { path: 'case-diary-form/:Fir_id', component: CaseDairyFormComponent },
               ]
            },
            {
                path: 'final-report', component: FinalReportMenuComponent,
                children: [
                { path: '', component: FinalReportGridComponent },
                { path: 'final-report-form/:Fir_id', component: FinalReportFormComponent },
               ]
            },

            //
            {
                path: 'court-proceedings', component: CoutrProceedingMenuComponent,
                children: [
                { path: '', component: CoutrProceedingGridComponent },
                { path: 'court-proceedings-form/:Fir_id', component: CoutrProceedingFormComponent },
               ]
            },

            // 

            {
                path: 'vehicle', component: UltilitiesComponent,
                children: [{ path: '', component: VehicleGridComponent }]
            },
            {
                path: 'vehicleform', component: UltilitiesComponent,
                children: [{ path: '', component: VehicleFormComponent }]
            },
            {
                path: 'correspondancetracking', component: CorrespondanceTrackingComponent,
                children: [{ path: '', component: CtGridComponent }]
            },
            {
                path: 'correspondancetracking-form', component: CorrespondanceTrackingComponent,
                children: [{ path: '', component: CtFormComponent }]
            },

        ]
    },
    {
        path: 'login', component: RegistrationComponent,
        children: [{ path: '', component: LoginComponent }]
    },

    {
        path: 'signup', component: RegistrationComponent,
        children: [{ path: '', component: SignupComponent }]
    },

    {
        path: 'forgot-password', component: RegistrationComponent,
        children: [{ path: '', component: ForgotPasswordComponent }]
    },


    { path: '', redirectTo: '/login', pathMatch: 'full' }
];


// WEBPACK FOOTER //
// ./src/route.ts